// extracted by mini-css-extract-plugin
export default {"header":"triggerWorkflow_header__3RnaG","editPersonalized":"triggerWorkflow_editPersonalized__-olPP"};